import React, {Component} from 'react';
import {NavBar, TextareaItem, Toast} from 'antd-mobile';
import {estimateAdd, estimateInfo, getPhone} from "../../../service/orderService";
import "./style.less";
import connect from "react-redux/es/connect/connect";
const sculpture = require('../../../common/image/sculpture.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class GradeDriver extends Component {
    constructor(props) {
        super(props);
        this.state = {
            evaluateVal:"",
            score:"",
            starList:[{name:'',flag:false},{name:'',flag:false},{name:'',flag:false},{name:'',flag:false},{name:'',flag:false}],
            gradeList:[
                {name:"准时到达目的地",isFlag: false},
                {name:"车内干净整洁",isFlag: false},
                {name:"驾驶娴熟平稳",isFlag: false},
                {name:"熟悉路线",isFlag: false},
                {name:"接送很快",isFlag: false},
                {name:"司机态度好",isFlag: false},
            ]
        };
    }
    componentDidMount() {}
    starChange(i){
        let flags = this.state.starList;
        if(i == 0){
            flags[0].flag = true;
            flags[1].flag = false;
            flags[2].flag = false;
            flags[3].flag = false;
            flags[4].flag = false;
            this.setState({score:1})
        }
        if(i == 1){
            flags[0].flag = true;
            flags[1].flag = true;
            flags[2].flag = false;
            flags[3].flag = false;
            flags[4].flag = false;
            this.setState({score:2})
        }
        if(i == 2){
            flags[0].flag = true;
            flags[1].flag = true;
            flags[2].flag = true;
            flags[3].flag = false;
            flags[4].flag = false;
            this.setState({score:3})
        }
        if(i == 3){
            flags[0].flag = true;
            flags[1].flag = true;
            flags[2].flag = true;
            flags[3].flag = true;
            flags[4].flag = false;
            this.setState({score:4})
        }
        if(i == 4){
            flags[0].flag = true;
            flags[1].flag = true;
            flags[2].flag = true;
            flags[3].flag = true;
            flags[4].flag = true;
            this.setState({score:5})
        }
        this.setState({starList:flags})
    };
    selGrade(res,i){
        let gradeList = this.state.gradeList;
        gradeList[i].isFlag = !gradeList[i].isFlag;
        this.setState({gradeList})
    }
    inputChange = (v, key) => {
        this.setState({[key]: v,});
    };
    submit = () => {
        const {starList,gradeList} = this.state;
        let grade = [];
        if(starList[0].flag === false){
            Toast.info('请对司机进行评分', 2);
            return
        }
/*        if (this.state.evaluateVal === '') {
            Toast.info('请输入您的评价', 2);
            return
        }*/
        gradeList.map((res)=>{
            if(res.isFlag === true){
                grade.push(res.name)
            }
        });
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                orderId: this.props.location.state.id,
                orderType:this.props.location.state.orderType,
                registereSource:1,
                driverId: this.props.location.state.driverId,
                commentContent:this.state.evaluateVal,
                score:this.state.score,
                tags:grade,
            },

        };
        Toast.loading("",0);
        estimateAdd(params).then((res)=>{
            if(res.data.code === '0000'){
                Toast.info("评价成功！",3,()=>this.props.history.goBack());
            }else{
                Toast.info(res.data.msg, 2);
            }
        })
    };
    callPhone(id){
        let params={
            source: 1,
            token:this.props.userInfo.token,
            data:{
                id: id,
            }
        };
        getPhone(params).then((res)=>{
            if(res.data.code == '0000'){
                window.location.href = `tel://${res.data.data.middleNumber}`;
            }else{
                Toast.info(res.data.msg,2)
            }
        })
    }
    render(){
        return(
            <div className="gradeDriver">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >评价</NavBar>
                <div className="warp">
                    <div className="content">
                        <div className="top">
                            <div className="driver">
                                <div><img src={sculpture}/></div>
                                <div className="driverInfo">
                                    <div>{this.props.location.state.driverName} <i className="icon iconfont iconpingfenxianshi" /><span>{this.props.location.state.stars}分</span> </div>
                                    <div>{this.props.location.state.carNum}</div>
                                    <div>{this.props.location.state.carModel}</div>
                                </div>
                                <div>
                                    <a href={`tel:${this.props.location.state.dispatcherPhone}`}><i className="icon iconfont icondingdanxiangqingdianhua" /></a>
                                    {/*<span onClick={()=>this.callPhone(this.props.location.state.id)}><i className="icon iconfont icondingdanxiangqingdianhua" /></span>*/}
                                </div>
                            </div>


                            <div className="starBox">
                                <div className="stars">
                                    {this.state.starList.map((res,i)=>(
                                        <i onClick={()=>this.starChange(i)} key={i} className={this.state.starList[i].flag == true ?"icon iconfont iconpingfenxianshi" : "icon iconfont iconkongxing" }/>
                                    ))}
                                </div>
                                <div className="gradeBar">
                                    {
                                        this.state.gradeList.map((res,i)=>(
                                            <div className={res.isFlag === true ? "current" :null} key={i} onClick={()=>this.selGrade(res,i)}>{res.name}</div>
                                        ))
                                    }
                                </div>
                                <TextareaItem
                                    className="text"
                                    rows={3}
                                    value={this.state.evaluateVal}
                                    placeholder="在此写下你想说的"
                                    onChange={v => this.inputChange(v, 'evaluateVal')}
                                    autoHeight="autoHeight "
                                />
                            </div>
                        </div>

                        <button onClick={this.submit}>提交</button>

                    </div>

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/member/GradeDriver/index.js